import axios from 'axios';

const memberReferralService = {
  getReferralCampaigns: (merchantId, params = {}) =>
    axios.get(`/api/merchants/${merchantId}/campaigns`, {
      params: {
        type: 'member_referral',
        current_campaign: true,
        ...params,
      },
    }),
  generateReferralCode: () => axios.post('/api/users/generate_referral_code'),
};

export default memberReferralService;
